import React from 'react';
import {
    CompetitionName,
    EventHeaderGroup,
    EventHeaderGroupSelection,
} from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventsGroupHeader6Pack.style';
import { getMarketNameNFL } from 'src/domains/layouts/shared/translations/markets';
import { observer } from 'src/utils/mobx-react';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const HomepageWidgetNFLHeader = observer('HomepageWidgetNFLHeader', (): JSX.Element | null => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;
    const marketsNamesNFL = getMarketNameNFL(languagesState.getTranslation);

    return (
        <EventHeaderGroup>
            <CompetitionName>NFL</CompetitionName>

            {breakpointsState.desktop.isBiggerOrEq === true &&
                marketsNamesNFL.map((marketName) => {
                    return (
                        <EventHeaderGroupSelection
                            key={marketName}
                            variant={configState.componentVariants.sportsbookVariant}
                        >
                            {marketName}
                        </EventHeaderGroupSelection>
                    );
                })}
        </EventHeaderGroup>
    );
});
